import { allBookingStates } from '../../status-transition-rules/booking.transitions';
import TableFilter from '../table-models/TableFilter';

export const defaultBookingsFilters: TableFilter[] = [
    { field: 'state', label: 'Exam Event State', value: '', availableStates: allBookingStates }
];